import React, { useRef } from 'react'
import { Col, Form } from 'react-bootstrap'
import LabelCustomSmall from '../../../../label-custom-small'
import { Controller } from 'react-hook-form'
import Autocomplete from '../../../../custom/autocomplete'
import useNumberInput from '../../../../../helper/input-fix-num'
import UseDropPaymentGroups from '../../../../../hooks/use-drop-payment-groups'

export default function AccountCard({
  isRead,
  control,
  errors,
  payments,
  dataDetail,
  banks
}) {
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)
  const paymentGroups = UseDropPaymentGroups()
  return (
    <>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          ประเภทการจ่ายเงิน
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'payment'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                options={payments}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.payment ?? '-'}</div>
        )}
        {errors.payment?.message && (
          <label className="small text-danger">{errors.payment.message}</label>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          บัญชีธนาคาร
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'bank'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                disabled={isRead}
                options={banks}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.bank ?? '-'}</div>
        )}
        {errors.bank?.message && (
          <label className="small text-danger">{errors.bank.message}</label>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          เลขบัญชี
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'codeBank'}
            control={control}
            render={({
              field: { onChange, value = dataDetail?.account_no ?? '-', ref }
            }) => (
              <Form.Control
                ref={ref}
                disabled={isRead}
                value={value}
                maxLength={15}
                onChange={onChange}
                onKeyDown={handleKeyDownNum}
              />
            )}
          />
        ) : (
          <div className="fw-light small">{dataDetail?.account_no ?? '-'}</div>
        )}
        {errors.codeBank?.message && (
          <label className="small text-danger">{errors.codeBank.message}</label>
        )}
      </ColFrom>

      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          Payment Group
        </LabelCustomSmall>
        {!isRead ? (
          <Controller
            name={'paymentGroup'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <Autocomplete
                options={paymentGroups}
                value={value}
                onChange={onChange}
              />
            )}
          />
        ) : (
          <div className="fw-light small">
            {dataDetail?.payment_group ?? '-'}
          </div>
        )}
        {errors.paymentGroup?.message && (
          <label className="small text-danger">
            {errors.paymentGroup.message}
          </label>
        )}
      </ColFrom>
    </>
  )
}

const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={3} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
